export default __webpack_public_path__ + "static/media/eyeOpenIcon.089376d4.svg";